import { createContext, useContext } from 'react';

export type VideoEditingFontSize = 'small' | 'medium' | 'large';

export const VIDEO_EDITING_FONT_SIZE_STORAGE_KEY = 'video-editing-font-size';

export const VIDEO_EDITING_FONT_SCALES: Record<VideoEditingFontSize, number> = {
  small: 0.9,
  medium: 1,
  large: 1.15,
};

export const VideoEditingFontScaleContext = createContext(1);

export const useVideoEditingFontScale = () => useContext(VideoEditingFontScaleContext);

export function loadVideoEditingFontSize(): VideoEditingFontSize {
  try {
    const value = localStorage.getItem(VIDEO_EDITING_FONT_SIZE_STORAGE_KEY);
    if (value === 'small' || value === 'medium' || value === 'large') return value;
  } catch { /* preference only */ }
  return 'medium';
}

export function saveVideoEditingFontSize(value: VideoEditingFontSize): void {
  try { localStorage.setItem(VIDEO_EDITING_FONT_SIZE_STORAGE_KEY, value); } catch { /* preference only */ }
}

export function scaleFontSize(value: string | number | undefined, scale: number): string | number | undefined {
  if (typeof value === 'number') return value * scale;
  const match = value?.match(/^([\d.]+)(px|rem|em)$/);
  return match ? `${Number(match[1]) * scale}${match[2]}` : value;
}
